export default "__VITE_ASSET__R9_S0mVs__"